export default __webpack_public_path__ + "images/4121e4e07a16a76d0f431a1a89bdff4e-charity_and_causes.webp";